import { render, staticRenderFns } from "./valmistumispyynnon-tarkistus-yek.vue?vue&type=template&id=41721550&scoped=true&"
import script from "./valmistumispyynnon-tarkistus-yek.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynnon-tarkistus-yek.vue?vue&type=script&lang=ts&"
import style0 from "./valmistumispyynnon-tarkistus-yek.vue?vue&type=style&index=0&id=41721550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41721550",
  null
  
)

export default component.exports